export default __webpack_public_path__ + "static/media/ico_search_w.0ad3e0c6.svg";